import React, { FC } from 'react';
import styled from 'styled-components';
import {
    SkeletonBlock,
    SkeletonFlexSpacer,
    SkeletonFullscreenContent,
    SkeletonFullscreenOverlay,
    SkeletonFullscreenTopBar,
    SkeletonResponsiveGrid,
    SkeletonRow,
    SkeletonStack,
    SkeletonSurface
} from 'src/components/widgets/skeleton';

const StudioContent = styled(SkeletonFullscreenContent)`
    align-items: stretch;
    justify-content: stretch;
    padding: 24px 40px 36px;
    overflow: auto;
`;

const StudioHome = styled.div`
    width: 100%;
    max-width: 1300px;
    margin: 0 auto;
`;

const ToolCardSkeleton: FC<{ $tall?: boolean }> = ({ $tall }) => (
    <SkeletonSurface $padding='14px' $radius='10px'>
        <SkeletonRow $gap='14px' $align='center'>
            <SkeletonBlock $width={$tall ? '116px' : '96px'} $height={$tall ? '92px' : '72px'} $radius='8px' />
            <SkeletonStack $gap='10px' $flex='1'>
                <SkeletonBlock $width='46%' $height='18px' />
                <SkeletonBlock $width='86%' $height='12px' />
                <SkeletonBlock $width='72%' $height='12px' />
            </SkeletonStack>
        </SkeletonRow>
    </SkeletonSurface>
);

export const AiStudioPageSkeleton: FC = () => (
    <SkeletonFullscreenOverlay aria-hidden='true' $background='#f8fafc' $zIndex={20}>
        <SkeletonFullscreenTopBar>
            <SkeletonBlock $width='180px' $height='28px' />
            <SkeletonFlexSpacer />
            <SkeletonBlock $width='34px' $height='34px' $radius='8px' />
        </SkeletonFullscreenTopBar>
        <StudioContent>
            <StudioHome>
                <SkeletonStack $gap='28px' $align='center'>
                    <SkeletonStack $gap='12px' $align='center' $width='100%' $margin='4px 0 0'>
                        <SkeletonBlock $width='min(460px, 80%)' $height='42px' />
                        <SkeletonBlock $width='min(820px, 92%)' $height='15px' />
                        <SkeletonBlock $width='120px' $height='13px' />
                    </SkeletonStack>
                    <SkeletonStack $gap='14px' $width='100%'>
                        <SkeletonRow $gap='12px'>
                            <SkeletonBlock $width='112px' $height='12px' />
                            <SkeletonBlock $height='1px' />
                        </SkeletonRow>
                        <SkeletonResponsiveGrid $columns='repeat(3, minmax(0, 1fr))' $gap='14px'>
                            {Array.from({ length: 7 }).map((_, index) => (
                                <ToolCardSkeleton key={index} />
                            ))}
                        </SkeletonResponsiveGrid>
                    </SkeletonStack>
                    <SkeletonStack $gap='14px' $width='100%'>
                        <SkeletonRow $gap='12px'>
                            <SkeletonBlock $width='92px' $height='12px' />
                            <SkeletonBlock $height='1px' />
                        </SkeletonRow>
                        <SkeletonResponsiveGrid $columns='repeat(3, minmax(0, 1fr))' $gap='14px'>
                            {Array.from({ length: 3 }).map((_, index) => (
                                <ToolCardSkeleton key={index} $tall />
                            ))}
                        </SkeletonResponsiveGrid>
                    </SkeletonStack>
                </SkeletonStack>
            </StudioHome>
        </StudioContent>
    </SkeletonFullscreenOverlay>
);
